import playSetup from "./play"
import sheetSetup from "./mySheet"
import generalSetup from "./general"
import historySetup from "./history"
import collectSetup from "./collect"
import psersonSetup from "./personPlay"
import { proxy } from "valtio"

const store = proxy({
  playStore: playSetup,
  sheetStore: sheetSetup,
  generalStore: generalSetup,
  historyStore: historySetup,
  collectStore: collectSetup,
  personStore: psersonSetup
})
export default store
